var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, getCompletedAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const prefix = "ANALYSIS_EDIT";
const panelToggleActionType = `${prefix}/panel/open`;
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD`,
  LOADING: `${prefix}/${resource}/LOADING`,
  LOADED: `${prefix}/${resource}/LOADED`
});
const defaultReducerState = {
  analysisEditAsync: getDefaultAsyncWrapperObj(),
  isEditPanelOpen: false,
  stepId: "",
  studyId: 0
};
const updateAnalysisActionTypes = createActionTypes("updateAnalysisStudy");
const updateAnalysis = (analysisEditRequest, onDone) => {
  return {
    type: updateAnalysisActionTypes.LOAD,
    payload: {
      analysisEditRequest,
      onDone
    }
  };
};
const updatingAnalysis = () => {
  return {
    type: updateAnalysisActionTypes.LOADING,
    payload: {}
  };
};
const updatedAnalysis = (analysisEditAsync) => {
  return {
    type: updateAnalysisActionTypes.LOADED,
    payload: {
      analysisEditAsync
    }
  };
};
const editPanelViewChange = (stepId, studyId, isEditPanelOpen) => {
  return {
    type: panelToggleActionType,
    payload: {
      stepId,
      studyId,
      isEditPanelOpen
    }
  };
};
const analysisEditReducer = (state = defaultReducerState, action) => {
  var _a, _b, _c, _d, _e, _f;
  switch (action.type) {
    case updateAnalysisActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        analysisEditAsync: __spreadProps(__spreadValues({}, state.analysisEditAsync), {
          status: AsyncRequestStatus.Pending
        })
      });
    case updateAnalysisActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        analysisEditAsync: __spreadValues({}, getCompletedAsyncWrapperObj(
          (_b = (_a = action.payload.analysisEditAsync) == null ? void 0 : _a.data) != null ? _b : "",
          (_d = (_c = action.payload.analysisEditAsync) == null ? void 0 : _c.error) != null ? _d : ""
        ))
      });
    case panelToggleActionType:
      return __spreadProps(__spreadValues({}, state), {
        stepId: (_e = action.payload.stepId) != null ? _e : "",
        studyId: (_f = action.payload.studyId) != null ? _f : 0,
        isEditPanelOpen: action.payload.isEditPanelOpen || false
      });
    default:
      return state;
  }
};
export {
  analysisEditReducer,
  createActionTypes,
  analysisEditReducer as default,
  defaultReducerState,
  editPanelViewChange,
  panelToggleActionType,
  updateAnalysis,
  updateAnalysisActionTypes,
  updatedAnalysis,
  updatingAnalysis
};
//# sourceMappingURL=AnalysisEdit.ducks.js.map
